// @ts-nocheck
/* eslint-disable */
export const burgerIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.267 10.667H2.733c-1 0-1.4.2-1.4.7v1.267c0 .499.4.7 1.4.7h10.534c1 0 1.4-.201 1.4-.7v-1.268c0-.498-.4-.7-1.4-.7m0-7.999H2.733c-1 0-1.4.2-1.4.7v1.267c0 .499.4.7 1.4.7h10.534c1 0 1.4-.201 1.4-.7V3.366c0-.499-.4-.7-1.4-.7m0 4.001H2.733c-1 0-1.4.2-1.4.7v1.267c0 .499.4.7 1.4.7h10.534c1 0 1.4-.201 1.4-.7V7.366c0-.499-.4-.7-1.4-.7"/></svg>`,
    name: 'burger' as const
};